import { RulesName } from '../enums';

export const verifyProductRules = (ruleType, ruleName, productId, products) => {
  const product = products.find(product => product.productID === productId);
  const existRules = !!(product?.rules);
  const rule = existRules && product.rules?.[ruleType]?.[ruleName];
  return existRules && rule?.length > 0 && rule;
};


export const verifyProductsRules = (ruleType, ruleName, productsIds, products) => {
  if (!Array.isArray(productsIds)) return verifyProductRules(ruleType, ruleName, productsIds, products);
  const productsInRules = productsIds.map(productId => {
    const rule = verifyProductRules(ruleType, ruleName, productId, products);
    return rule;
  });
  const uniqueProductInRules = [...new Set(productsInRules.flat())];
  return uniqueProductInRules;
}

export const applyRule = (ruleName, rule, productId, products) => {
  switch (ruleName) {
    case RulesName.PLAN_ADDONS_OFFERING:
      return applyAddOnsOfferingRule(rule, productId, products);
    case RulesName.UPGRADEABLE_TO:
      return applyUpgradeableToRule(rule, productId, products);
    case RulesName.DOWNGRADEABLE_TO:
      return applyDowngradeableToRule(rule, productId, products);
    case RulesName.INCOMPATIBLE_OFFERINGS:
      return applyIncompatibleOfferingsRule(rule, productId, products);
    case RulesName.PLAN_INCLUDE_ADDONS:
      return includeAddOnsRule(rule, products);
  }
}

export const applyAddOnsOfferingRule = (rule, productId, products) => {
  const filteredList = products.filter(product => product.productID !== productId && rule.includes(product.productID));
  return filteredList;
};

export const applyUpgradeableToRule = (rules, productsIds, products) => {
  const filteredAddonsBySubs = products.filter(product => !productsIds.includes(product.productID));
  return filteredAddonsBySubs.filter(product => (rules.includes(product.productID)) || !(products.rule?.additionalPurchase?.upgradeableTo));
};

export const applyIncompatibleOfferingsRule = (rules, productsIds, products) => {
  const filteredAddonsBySubs = products.filter(product => !productsIds.includes(product.productID));
  return filteredAddonsBySubs.filter(product => !(rules.includes(product.productID)));
};

export const applyDowngradeableToRule = (rules, productsIds, products) => {
  const filteredAddonsBySubs = products.filter(product => !productsIds.includes(product.productID));
  return filteredAddonsBySubs.filter(product => (rules.includes(product.productID)));
};

export const includeAddOnsRule = (rules, products) => {
  const filteredAddOns = rules.map(rule => rule.productId);
  return products.filter(product => !(filteredAddOns.includes(product.productID)));
};

export const verifyDowngradeableAddon = (addOnInfo, products, addOnSubscriptions) => {
  const comboAddOns = products.filter(
    product => product.rules?.additionalPurchase?.downgradeableTo &&
      product.rules?.additionalPurchase?.downgradeableTo.length > 0
  );
  const comboSubs = addOnSubscriptions.filter(sub => comboAddOns.some(comboProd => comboProd.productID === sub.productId));
  const comboSubsWithInfo = comboSubs.map(sub => comboAddOns.find(combo => combo.productID === sub.productId));
  return comboSubsWithInfo.some(combo => {
    const downgradeableRule = combo.rules?.additionalPurchase?.downgradeableTo;
    const existDowngradeRule = downgradeableRule && downgradeableRule.length > 0;
    return existDowngradeRule && downgradeableRule.includes(addOnInfo?.productID);
  });
};
